import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'nsc-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    standalone: false
})
export class CardComponent implements OnInit {
  @Input() error = false;
  @Input() className: string;
  values = {
    className: '',
  }
  constructor() { }

  ngOnInit() {
    if (this.error) {
      this.values.className = "system-message";
      if (this.className) {
        this.values.className = `${this.values.className} ${this.className}`;
      } else {
        this.values.className = `${this.values.className} error`;
      }
    }
  }

}
